// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingPage_wrapper__Biuo3","root":"LandingPage_root__3jikq","footer":"LandingPage_footer___nqao"};